import { ParameterType } from '@/study-search/enums';

import { AttendanceFilterOptionValue, FilterOptionInformation } from '@studyportals/search-filters';
import { FilterDefinition } from '../FilterDefinition';

class DistanceLearningAttendanceFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DELIVERY_METHOD,
			[
				new FilterOptionInformation('Fully online', AttendanceFilterOptionValue.ONLINE, 'online', 'Online'),
				new FilterOptionInformation('Blended', AttendanceFilterOptionValue.BLENDED, '', '')
			],
			[AttendanceFilterOptionValue.ONLINE],
			true
		);
	}
}

export default new DistanceLearningAttendanceFilterDefinition();
